import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getBasePrice(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createBasePrice(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/base-price" + pathname, body);
}

export async function updateBasePrice(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/base-price" + pathname, body);
}

export async function deleteBasePrice(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/base-price" + pathname, { data: body });
}

export async function getBasePriceByUnits(unitIds) {
  return await instance({ baseURL: baseURL }).post("/base-price/by-units", {
    units: unitIds,
  });
}

export async function syncUnitSubtotals(unitIds) {
  return await instance({ baseURL: baseURL }).post(
    "/base-price/sync-unit-subtotals",
    { units: unitIds },
  );
}
